import ChartGlassPanel from '../../components/ChartGlassPanel';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import useSalaryStackedBarData from './useSalaryStackedBarData';

export default function SalaryStackedBarChart() {
  const data = useSalaryStackedBarData();
  return (
    <ChartGlassPanel>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="salary" stackId="a" fill="#2563eb" name="Salary" />
              <Bar dataKey="bonus" stackId="a" fill="#22c55e" name="Bonus" />
              <Bar dataKey="deductions" stackId="a" fill="#e11d48" name="Deductions" />
            </BarChart>
          </ResponsiveContainer>
        </div>
    </ChartGlassPanel>
  );
}
